export enum ModuleCodes {
  SOCIAL = 'SOCIAL',
  SHOP = 'SHOP',
  RESTAURANT = 'RESTAURANT',
  TRAVEL_TOUR = 'TRAVEL_TOUR',
  HOTEL = 'HOTEL',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
}
